import React from "react";
import ProjectExtractionSheets from "./models/project-extraction-sheets.ts";
import ExtractionOperation from "./models/enums/extraction-operation.ts";

export interface ExtractionContextProps {
    isLoading: boolean;
    projectSheets: ProjectExtractionSheets | null;
    
    isDirty: boolean;
    isSaving: boolean;
    saveSheets: () => void;
    
    addSheet: (name: string) => void;
    updateSheetName: (id: string, newName: string) => void;
    removeSheet: (id: string) => void;
    
    addNode: (sheetId: string, nodeName: string) => void;
    updateNodeName: (sheetId: string, nodeId: string, newName: string) => void;
    addSubNode: (sheetId: string, nodeId: string, subNodeName: string) => void;
    removeNode: (sheetId: string, nodeId: string) => void;
    
    addArticle: (sheetId: string, nodeId: string, articleName: string) => void;
    updateArticleName: (sheetId: string, articleId: string, newName: string) => void;
    linkMeasuresToArticle: (sheetId: string, articleId: string, measureTypeId: string, associatedStoreysIds: string[]) => void;
    link3DToArticle: (sheetId: string, articleId: string, indicatorDefKeyName: string, associatedStoreysIds: number[]) => void;
    removeArticle: (sheetId: string, articleId: string) => void;
    
    updateArticleData: (sheetId: string, articleElementId: string, dataKey: string, operation: ExtractionOperation) => void;

    exportExcel: (sheetId: string) => Promise<void>;
}

export const ExtractionContext = React.createContext<ExtractionContextProps | undefined>(undefined);